import * as THREE from 'three';
import {
  BULLET_SPEED,
  BULLET_RADIUS,
  BULLET_LIFETIME,
  BULLET_DAMAGE,
  COLOR_BULLET_PLAYER,
  COLOR_BULLET_ENEMY,
} from '../config';

export class Bullet {
  readonly mesh: THREE.Mesh;
  readonly direction: THREE.Vector3;
  readonly speed: number;
  readonly damage: number;
  readonly isPlayerBullet: boolean;
  readonly trail: THREE.Points;

  age = 0; // 已存在时间(秒)
  alive = true;

  // 碰撞检测用
  readonly radius = BULLET_RADIUS;

  constructor(
    position: THREE.Vector3,
    direction: THREE.Vector3,
    isPlayerBullet: boolean,
  ) {
    this.isPlayerBullet = isPlayerBullet;
    this.direction = direction.clone().normalize();
    this.speed = BULLET_SPEED;
    this.damage = BULLET_DAMAGE;

    const color = isPlayerBullet ? COLOR_BULLET_PLAYER : COLOR_BULLET_ENEMY;

    // 炮弹球体
    const geo = new THREE.SphereGeometry(BULLET_RADIUS, 8, 8);
    const mat = new THREE.MeshStandardMaterial({
      color,
      roughness: 0.2,
      metalness: 0.1,
      emissive: color,
      emissiveIntensity: 0.6,
    });
    this.mesh = new THREE.Mesh(geo, mat);
    this.mesh.position.copy(position);

    // 拖尾特效 (线段点)
    const trailGeo = new THREE.BufferGeometry();
    const trailPositions = new Float32Array(3 * 10); // 10个点
    for (let i = 0; i < 10; i++) {
      const t = i / 9;
      trailPositions[i * 3] = position.x - direction.x * t * 1.5;
      trailPositions[i * 3 + 1] = position.y - direction.y * t * 1.5;
      trailPositions[i * 3 + 2] = position.z - direction.z * t * 1.5;
    }
    trailGeo.setAttribute('position', new THREE.BufferAttribute(trailPositions, 3));
    const trailMat = new THREE.PointsMaterial({
      color,
      size: 0.2,
      transparent: true,
      opacity: 0.7,
      blending: THREE.AdditiveBlending,
      depthWrite: false,
    });
    this.trail = new THREE.Points(trailGeo, trailMat);
  }

  update(delta: number): void {
    this.age += delta;
    if (this.age >= BULLET_LIFETIME) {
      this.alive = false;
      return;
    }

    // 移动
    this.mesh.position.addScaledVector(this.direction, this.speed * delta);

    // 更新拖尾
    const positions = (this.trail.geometry.attributes.position as THREE.BufferAttribute).array as Float32Array;
    // 将旧点前移，最新点设为当前位置
    for (let i = positions.length - 3; i >= 3; i -= 3) {
      positions[i] = positions[i - 3];
      positions[i + 1] = positions[i - 2];
      positions[i + 2] = positions[i - 1];
    }
    positions[0] = this.mesh.position.x;
    positions[1] = this.mesh.position.y;
    positions[2] = this.mesh.position.z;
    this.trail.geometry.attributes.position.needsUpdate = true;

    // 拖尾跟随
    this.trail.position.copy(this.mesh.position);
  }

  dispose(): void {
    this.mesh.geometry.dispose();
    (this.mesh.material as THREE.Material).dispose();
    this.trail.geometry.dispose();
    (this.trail.material as THREE.Material).dispose();
  }
}
